import React, { useCallback } from 'react';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import * as urlUtil from '@theme/js/utils/url.util';
import { useAppSelector, useMyAccountSidebarSelector } from '@core/js/store/hooks';
import { BackboneReplacer } from '@theme/js/backbone/components/BackboneReplacer';
import { closeSidebar } from '@core/js/components/main/MyAccountSidebar/store/actions';
import { AccessibilityElement } from '@core/js/components/common/AccessibilityElement';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from '@core/js/components/main/DefaultHeader/hooks';

import style from './Inbox.scss';

export const Inbox: React.FC = () => {
    const translate = useComponentTranslations();
    const dispatch = useDispatch(); /* Lugano changes */
    const inboxWidget = useAppSelector(prop('inboxWidget'));
    const onInboxButtonClick = hooks.useOnInboxButtonClick();
    const hideInboxByUrl = urlUtil.getLocationParam('hideInbox') === '1';
    const showInbox = inboxWidget.showIcon && inboxWidget.enabled && !hideInboxByUrl;

    /* Lugano changes */
    const isOpened = useMyAccountSidebarSelector(prop('isOpened'));
    const onClick = useCallback(() => {
        isOpened && dispatch(closeSidebar());
        onInboxButtonClick();
    }, [dispatch, isOpened, onInboxButtonClick]);
    /* Lugano changes */

    return showInbox
        ? (
            <AccessibilityElement
                tagName="span"
                className={style.inbox}
                onClick={onClick} /* Lugano changes */
                aria-label={translate('header.inboxBtn')}
            >
                <span className={`${style.inboxIcon} icon-ico-s4w-mail`} /> {/* Lugano changes */}
                <BackboneReplacer
                    isHideBackboneClass={true} /* Lugano changes */
                    viewName="unreadmessagescount"
                    dynamicName="UNREAD_MESSAGES_COUNT"
                />
            </AccessibilityElement>
        )
        : null;
};
